import * as React from 'react';
import {
    IBuyboxState
} from '@msdyn365-commerce-modules/buybox';
import { IRwbBuyboxProps } from './rwb-buybox.props.autogenerated';
import { IRwbBuyboxData } from './rwb-buybox.data';

const _getClassNamePrefix = (typeName: string): string => {
    return typeName.toLocaleLowerCase() === 'quickview' ? 'rwb-quickView' : 'rwb-buybox';
};

export function getTotalInventory(
    props: IRwbBuyboxProps<IRwbBuyboxData>,
    state: IBuyboxState,
    chooseConfig: boolean
): React.ReactElement | undefined {

    const { typeName } = props;
    var className = _getClassNamePrefix(typeName);
    var classNameInventoryInfo =  `${className}__InventoryInfo`;
    var classNameStore =  `${className}__storeInventory`;
    var classNameShip = `${className}__shipInventory`;
    var classNameLabel = `${className}__inventory_label`;
    var classNameLabelStore = `${className}__inventory_store`;
    var classNameLabelShip = `${className}__inventory_ship`;
    var classNameLabelStoreName = `${className}__store_name`;

    var totalInventory = 0;
    var preferredStoreInventory:any = 0;
    var preferredStore = props.data.storeSelectorStateManager.result?.preferredStore;
    var preferredStoreName = preferredStore?.StoreName? preferredStore?.StoreName:'';

    var availabilities = props.data.availabilitiesWithHours.result;
    availabilities?.forEach (availability=>{
            var itemAvailabilities = availability.OrgUnitAvailability?.ItemAvailabilities;
            var inventory = 0;
            if (itemAvailabilities && itemAvailabilities[0]) {
                inventory = itemAvailabilities[0].AvailableQuantity?itemAvailabilities[0].AvailableQuantity:0;
                if (availability.OrgUnitAvailability?.OrgUnitLocation?.InventoryLocationId === preferredStore?.StoreId) {
                    preferredStoreInventory = inventory;

                }
            }
            totalInventory += inventory;
    });
    var uom = props.data.product.result?.DefaultUnitOfMeasure==='SQFT'?props.data.product.result?.DefaultUnitOfMeasure:'';
    var shipInventory:any = totalInventory - preferredStoreInventory;
    totalInventory = Math.round(totalInventory*100)/100;
    preferredStoreInventory = Math.round(preferredStoreInventory*100)/100;
    shipInventory = Math.round(shipInventory*100)/100;
    var preferredStoreInventoryStr ='';
    var shipInventoryStr = '';

    if (chooseConfig) {
        return (
            <div className={classNameLabel}>
                Choose a configuration
            </div>
        );
    } else {
        if (preferredStore) {
            if (preferredStoreInventory === 0) {
                classNameStore += '__notInStock';
                preferredStoreInventoryStr += "Not In Stock";
            } else {
                preferredStoreInventoryStr = `${preferredStoreInventory} ${uom} In Stock`;
            }

            if (shipInventory === 0) {
                classNameShip +='__notInStock';
                shipInventoryStr += "Not In Stock";
            } else {
                shipInventoryStr = `${shipInventory} ${uom} Available`;

            }
            return (
                <div>
                <div className={classNameLabelStoreName}>
                    {preferredStoreName}
                </div>
                <div className={classNameInventoryInfo}>
                    <div className={classNameLabelStore}>Pro Shop Pickup: <span className={classNameStore}>{preferredStoreInventoryStr}</span></div>
                    <div className={classNameLabelShip}>Ship to Store: <span className={classNameShip}>{shipInventoryStr}</span></div>
                </div>
                </div>
            );
        } else {
            return(
                <div className={classNameLabel}>
                    Pick a store to check inventory
                </div>
            );
        }
    }
}